import React, { useEffect } from 'react'
// components
import Link from '../Link';
import docsVersion from '../../utils/docsVersion'
// styles
import styles from './styles.module.less'

const DocHeader = ({ location }) => {
  useEffect(() => {
    loadJS();
  }, []);

  const loadJS = () => {
    if (window.docsearch) {
      window.docsearch({
        apiKey: '8f887d5b28fbb0aeb4b98fd3c4350cbd',
        indexName: 'getambassador',
        inputSelector: '#algolia-doc-search',
        debug: true,
      });
    } else {
      setTimeout(() => {
        loadJS();
      }, 500);
    }
  }

  return (
    <div className={styles.Container}>
      <div className={styles.VersionContainer}>
        <h4>Version:</h4>
        <div className={styles.Dropdown}>
          <button className={styles.DropdownButton}>
            {docsVersion((location || {}).pathname)}
            <span>&nbsp;</span>▾
        </button>
          <div className={styles.DropdownContent}>
            <Link to="/docs/pre-release/">Pre-release</Link>
            <Link to="/docs/latest/">Latest</Link>
            <Link to="/docs/1.12/">1.12</Link>
            <Link to="/docs/1.11/">1.11</Link>
            <Link to="/docs/1.10/">1.10</Link>
            <Link to="/docs/1.9/">1.9</Link>
            <Link to="/docs/1.8/">1.8</Link>
            <Link to="/docs/1.7/">1.7</Link>
            <Link to="/docs/1.6/">1.6</Link>
            <Link to="/docs/1.5/">1.5</Link>
            <Link to="/docs/1.4/">1.4</Link>
            <Link to="/docs/1.3/">1.3</Link>
          </div>
        </div>
      </div>
      <div className={styles.SearchContainer}>
        <h4>Search the Docs</h4>
        <input id="algolia-doc-search" placeholder="Enter doc search..." />
      </div>
    </div>
  )
}

export default DocHeader
